exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".titleAdminPage {\n  font-family: Helvetica, sans-serif;\n  font-size: 38px;\n  color: rgba(17, 17, 17, 0.8);\n  border-bottom: 3px solid #c0c0c0;\n  margin-bottom: 1em;\n  padding-top: 15px;\n  width: 100%;\n  padding-bottom: 5px;\n  text-transform: uppercase;\n  font-weight: 600;\n  letter-spacing: 3px; }\n\n.row {\n  margin: 10px 0; }\n  .row .col-12 {\n    margin-bottom: 20px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/admin/components/myaccount/my-account.component.scss
// module id = 1274
// module chunks = 0